<template>
  <div class="about">
    <h1>This is an about page. {{ username }}</h1>
  </div>
</template>

<script>
export default {
	name: 'AboutView',
	data() {
		return {
			isAuthenticated: false
		}
	},
	computed: {
		username() {
			console.log(this.$route.params.username)
			console.log(this.$route.query.username)
			return this.$route.query.username
		}
	},
	methods: {
		goToDashboard() {
			if (isAuthenticated) {
				this.$route.push('/dashborad')
			} else {
				this.$route.push('/login')
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/AboutView.vue